import { Controller } from "stimulus"
import { createElement, nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["entry", "header"]

  connect() {
    this.scheduleUpdate()
    this.recordUpdate()
  }

  disconnect() {
    this.cancelUpdate()
  }

  // Actions

  requestUpdate() {
    this.cancelUpdate()
    this.scheduleUpdate(250)
  }

  // Private

  scheduleUpdate(delay = this.updateInterval) {
    this.updateTimeout = setTimeout(() => this.update(), delay)
  }

  cancelUpdate() {
    clearTimeout(this.updateTimeout)
  }

  recordUpdate() {
    this.lastUpdateAt = new Date()
  }

  async update() {
    const fragment = await this.fetchUpdates()
    if (!fragment) return this.scheduleUpdate()

    const targets = this.findTargets(fragment)
    if (targets.length) this.recordUpdate()

    if (this.pageIsVisible) await nextFrame()
    this.removeDuplicateTargets(targets)
    this.element.prepend(fragment)

    this.scheduleUpdate()
  }

  async fetchUpdates() {
    const url = new URL(location)
    url.searchParams.set("since", this.lastUpdateAt.toISOString())

    const headers = { Accept: "text/html; fragment" }
    const response = await fetch(url, { headers }).catch(Response.error)
    const html = await response.text()

    if (response.ok) this.errorCount = 0
    if (response.ok) return createFragment(html)
    if (this.errorCount++ > 2) location.reload()
  }

  removeDuplicateTargets(targets) {
    for (const target of targets) {
      const id = this.targetId(target)
      if (id) this.findTarget(id)?.remove()
    }
  }

  targetAttribute = `data-${this.identifier}-target`
  idAttribute = `data-${this.identifier}-id`

  findTargets = (root = this.element) => [...root.querySelectorAll(`[${this.targetAttribute}]`)]
  findTarget = (id, root = this.element) => root.querySelector(`[${this.targetAttribute}][${this.idAttribute}="${id}"]`)
  targetId = (target) => target.getAttribute(this.idAttribute)

  get updateInterval() {
    return (this.pageIsActive ? 10000 : 30000) * (this.errorCount || 1)
  }

  get pageIsActive() {
    return document.visibilityState == "visible" && document.hasFocus()
  }

  #errorCount = 0

  get errorCount() {
    return this.#errorCount
  }

  set errorCount(count) {
    this.#errorCount = count
  }
}

function createFragment(innerHTML) {
  return createElement("template", { innerHTML }).content
}
